
import { useLandingForm, UseLandingFormProps } from "./hooks/useLandingForm";
import PersonalInfoSection from "./form-sections/PersonalInfoSection";
import EmailSection from "./form-sections/EmailSection";
import CredentialsSection from "./form-sections/CredentialsSection";
import CountrySection from "./form-sections/CountrySection";
import AccountDeletionSection from "./form-sections/AccountDeletionSection";
import ConsentSection from "./form-sections/ConsentSection";
import SubmitSection from "./form-sections/SubmitSection";

const LandingForm = ({ onAccessGranted }: UseLandingFormProps) => {
  console.log('🟣 LandingForm component rendered');
  
  const {
    formData,
    consentChecked,
    isSubmitting,
    handleChange,
    handleCountryChange,
    setConsentChecked,
    handleSubmit,
    fillTestCredentials
  } = useLandingForm({ onAccessGranted });

  console.log('🟣 LandingForm state - isSubmitting:', isSubmitting);

  return (
    <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
      <div className="space-y-4">
        <PersonalInfoSection formData={formData} handleChange={handleChange} />
        <EmailSection formData={formData} handleChange={handleChange} />
        <CredentialsSection formData={formData} handleChange={handleChange} />
        <CountrySection formData={formData} handleCountryChange={handleCountryChange} />
        <AccountDeletionSection />
        <ConsentSection consentChecked={consentChecked} setConsentChecked={setConsentChecked} />
      </div>

      <SubmitSection isSubmitting={isSubmitting} fillTestCredentials={fillTestCredentials} />
    </form>
  );
};

export default LandingForm;
